import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Prelogin
import { PartnerRegistrationComponent } from './prelogin/partner-registration/partner-registration.component';
import { CounsellorSignupPreprocessingComponent } from './prelogin/counsellor-signup-preprocessing/counsellor-signup-preprocessing.component';
import { CounsellorRegistrationComponent } from './prelogin/counsellor-registration/counsellor-registration.component';
import { LoginComponent } from './prelogin/login/login.component';
import { ResetPasswordComponent } from './prelogin/reset-password/reset-password.component';
import { ForgotPasswordComponent } from './prelogin/forgot-password/forgot-password.component';

// Menu - Dashboard
import { MyDashboardComponent } from './dashboard/my-dashboard/my-dashboard.component';

// Menu - My Website
import { BrandingComponent } from './dashboard/branding/branding.component';
import { InformationComponent } from './dashboard/information/information.component';
import { TestimonialsComponent } from './dashboard/testimonials/testimonials.component';

// Menu - My Organization
import { OrganizationDetailsComponent } from './dashboard/organization-details/organization-details.component';
import { MyTeamComponent } from './dashboard/my-team/my-team.component';
import { BillingInvoiceComponent } from './dashboard/billing-invoice/billing-invoice.component';
import { AssessmentCouponsComponent } from './dashboard/assessment-coupons/assessment-coupons.component';

// Upgrade Page
import { UpgradeComponent } from './dashboard/upgrade/upgrade.component';

// Menu - Student
import { StudentListComponent } from './dashboard/student-list/student-list.component';

// Student Profile
import { StudentProfileComponent } from './dashboard/student-profile/student-profile.component';

// Menu - My Planning Tools
import { ExamCornerComponent } from './dashboard/exam-corner/exam-corner.component';
import { ExamCornerDetailsComponent } from './dashboard/exam-corner-details/exam-corner-details.component';
import { ScholarshipsComponent } from './dashboard/scholarships/scholarships.component';
import { RoadmapComponent } from './dashboard/roadmap/roadmap.component';

import { AuthGuard } from './auth.guard';
import { PageNotFoundComponent } from './common/page-not-found/page-not-found.component';

// Roles
// 0 - Partner
// 1 - Admin
// 2 - Counsellor

const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  {
    path: 'partner-registration',
    component: PartnerRegistrationComponent
  },
  {
    path: 'counselorSignup',
    component: CounsellorSignupPreprocessingComponent
  },
  {
    path: 'counsellor-registration',
    component: CounsellorRegistrationComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'my-dashboard',
    component: MyDashboardComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1, 2] }
  },
  {
    path: 'branding',
    component: BrandingComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1] }
  },
  {
    path: 'information',
    component: InformationComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1] }
  },
  {
    path: 'testimonials',
    component: TestimonialsComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1] }
  },
  {
    path: 'organization-details',
    component: OrganizationDetailsComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1] }
  },
  {
    path: 'my-team',
    component: MyTeamComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1] }
  },
  {
    path: 'billing',
    component: BillingInvoiceComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0] }
  },
  {
    path: 'assessment-coupons',
    component: AssessmentCouponsComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0] }
  },
  {
    path: 'upgrade',
    component: UpgradeComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0] }
  },
  {
    path: 'student-list',
    component: StudentListComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1, 2] }
  },
  {
    path: 'student-profile/:student_id',
    component: StudentProfileComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1, 2] }
  },
  {
    path: 'exam-corner',
    component: ExamCornerComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1, 2] }
  },
  {
    path: 'exam-corner/:mep_id/:id',
    component: ExamCornerDetailsComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1, 2] }
  },
  {
    path: 'scholarships',
    component: ScholarshipsComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1, 2] }
  },
  {
    path: 'roadmap',
    component: RoadmapComponent,
    canActivate: [AuthGuard],
    data: { expectedRole: [0, 1, 2] }
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
